


































































































































import {
  createComponent,
  inject,
  onMounted,
  computed,
  ref,
  reactive,
  SetupContext
} from "@vue/composition-api";

import SnackBar from "../../../Common/SnackBar.vue";
import AupayChargeKey from "@/components/aupay-charge-key";
import WalletKey from "@/components/wallet-key";
import MemberKey from "@/components/member-key";
import SnackbarKey from "@/components/snackbar-key";
import router from "@/router/index";

interface SnackBar {
  [prop: string]: any;
}

export default createComponent({
  components: { SnackBar },
  setup(props: {}, context: SetupContext) {
    const walletStore = inject(WalletKey);
    if (!walletStore) {
      throw new Error(`${WalletKey} is not provided`);
    }
    const memberStore = inject(MemberKey);
    if (!memberStore) {
      throw new Error(`${MemberKey} is not provided`);
    }
    const aupayChargeStore = inject(AupayChargeKey);
    if (!aupayChargeStore) {
      throw new Error(`${AupayChargeKey} is not provided`);
    }

    // storeを注入
    const snackbarStore = inject(SnackbarKey);
    if (!snackbarStore) {
      throw new Error(`${snackbarStore} is not provided`);
    }
    // 登録ボタン押下後のスナックバー制御
    const snackbar = reactive<SnackBar>({
      display: false,
      error: false,
      message: ""
    });
    const globalStore = context.root.$store;
    const loadedFlag = ref<boolean>(false);
    const accessToken = computed(() => globalStore.auth.token);
    const member = computed(() => memberStore.member);
    const chargeEnabledForPinLockError = computed(
      () => aupayChargeStore.chargeEnabledForPinLockError
    );

    const isShowPassword = ref<boolean>(false);
    const isBtnDisable = ref<boolean>(false);
    const atmPinCode = ref<string>("");

    const requireRule = (value: string) => !!value || "必須入力です。";

    const inputUpdatePassword = (e: string) => {
      if (e == "") {
        isBtnDisable.value = true;
      } else {
        isBtnDisable.value = false;
      }
    };

    const request = async () => {
      loadedFlag.value = true;

      if (!chargeEnabledForPinLockError.value) {
        const info = {
          message: "au PAY 残高へのチャージに失敗しました。",
          error: true,
          display: true
        };
        snackbarStore.displaySnackbar(info);
        context.root.$router.push({name: "AupayChargeRequestError"});
        return;
      }

      const response = await aupayChargeStore.postAupayChargeRequest(
        String(Math.floor(member.value.member_no)),
        member.value.card_number,
        atmPinCode.value,
      );
      // APIの実行結果に依ってメッセージを変える
      if (response.status == 200) {
        // 成功メッセージがチャージ画面で出すのでstoreに値を保存
        const info = {
          message: "チャージを行いました",
          error: false,
          display: true
        };
        snackbarStore.displaySnackbar(info);
        // 成功の場合は完了画面へ遷移
        context.root.$router.push({name: "AupayChargeRequestComplete"});
        // チャージ依頼前のエラーであればエラー画面に遷移する
      } else if (
        response.data["messages"] != "口座情報の更新に失敗しました。"
      ) {
        const info = {
          message: aupayChargeStore.errorMessage,
          error: true,
          display: true
        };
        snackbarStore.displaySnackbar(info);
        context.root.$router.push({name: "AupayChargeRequestError"});
        // チャージ依頼後のエラーであればユーザーには知らせず、画面側では成功扱いにする
      } else {
        const info = {
          message: "Aupayチャージ依頼を行いました",
          error: false,
          display: true
        };
        snackbarStore.displaySnackbar(info);
        context.root.$router.push({name: "AupayChargeRequestComplete"});
      }
      // API実行結果が返ってきた段階でロード終了
      loadedFlag.value = false;
      // エラー四秒後：成功二秒後にスナックバーを初期化する
      setTimeout(
        () => {
          snackbar.display = false;
          snackbar.error = false;
          snackbar.message = "";
        },
        snackbar.error ? 4000 : 2500
      );
    };

    onMounted(async () => {
      loadedFlag.value = true;
      memberStore.setAuthorizationHeader(accessToken.value);
      walletStore.setAuthorizationHeader(accessToken.value);
      await memberStore.getMember();
      await aupayChargeStore.getAupayAccount(member.value.member_no);
      await aupayChargeStore.getPinLockErrorChargeEnabled(
        String(Math.floor(member.value.member_no))
      );
      loadedFlag.value = false;
      isBtnDisable.value = true;
    });

    return {
      loadedFlag,
      snackbar,
      isShowPassword,
      isBtnDisable,
      atmPinCode,
      request,
      requireRule,
      inputUpdatePassword,
      aupayChargeStore
    };
  }
});
